import type { AppState } from '../../types';

export type PostLikes = {
  liked: boolean;
  likeCount: number;
  isLikeInProgress: boolean;
};

export type PostLikesReducer = {
  [postId: string]: PostLikes;
};

export const getPostLikes = (state: AppState, postId: string) => state.postLikes[postId] || {};

export const getIsPostLiked = (state: AppState, postId: string): boolean | undefined =>
  getPostLikes(state, postId).liked;

export const getPostLikeCount = (state: AppState, postId: string): number | undefined =>
  getPostLikes(state, postId).likeCount;
